import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm$selectedChat;
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-drawer", {
    staticClass: "im-chat-drawer",
    attrs: {
      visible: _vm.drawerVisible,
      direction: "rtl",
      size: _vm.drawerSize,
      "with-header": false,
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.drawerVisible = $event;
      },
      close: _vm.handleClose,
      open: _vm.handleOpen
    }
  }, [_c("div", {
    staticClass: "im-chat-container"
  }, [_c("div", {
    staticClass: "chat-header"
  }, [_c("div", {
    staticClass: "header-left"
  }, [_vm.view !== "list" ? _c("i", {
    staticClass: "el-icon-arrow-left back-btn",
    on: {
      click: _vm.goBack
    }
  }) : _c("i", {
    staticClass: "el-icon-chat-dot-round"
  }), _c("span", [_vm._v(_vm._s(_vm.headerTitle))])]), _c("div", {
    staticClass: "header-right"
  }, [_vm.view === "list" && _vm.desktopNotifySupported && _vm.desktopNotifyPermission !== "granted" ? _c("el-button", {
    staticClass: "header-btn header-btn--notify",
    attrs: {
      type: "text",
      icon: "el-icon-bell"
    },
    on: {
      click: _vm.enableDesktopNotify
    }
  }, [_vm._v(" 开启桌面通知 ")]) : _vm._e(), _vm.view === "list" ? _c("el-button", {
    staticClass: "header-btn",
    attrs: {
      type: "text",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.openNewChat
    }
  }) : _vm._e(), _vm.view === "messages" && _vm.selectedChatIsGroup ? _c("el-button", {
    staticClass: "header-btn",
    attrs: {
      type: "text",
      icon: "el-icon-user-solid"
    },
    on: {
      click: _vm.openGroupDetail
    }
  }) : _vm._e(), _c("el-button", {
    staticClass: "header-btn close-btn",
    attrs: {
      type: "text",
      icon: "el-icon-close"
    },
    on: {
      click: _vm.handleClose
    }
  })], 1)]), _vm.view === "list" ? _c("div", {
    staticClass: "chat-list"
  }, [_c("div", {
    staticClass: "chat-list-toolbar"
  }, [_c("el-input", {
    attrs: {
      placeholder: "搜索会话、联系人或消息摘要",
      "prefix-icon": "el-icon-search",
      clearable: ""
    },
    model: {
      value: _vm.listSearchKeyword,
      callback: function callback($$v) {
        _vm.listSearchKeyword = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "listSearchKeyword"
    }
  }), _c("div", {
    staticClass: "chat-filter-tabs"
  }, [_vm._l(_vm.chatFilters, function (item) {
    return _c("button", {
      key: item.value,
      staticClass: "chat-filter-tab",
      class: {
        active: _vm.listFilter === item.value
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          _vm.listFilter = item.value;
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), _vm.customerServiceAgent ? _c("button", {
    staticClass: "chat-filter-tab chat-filter-tab--service",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.openCustomerService
    }
  }, [_vm._v(" 网页咨询 ")]) : _vm._e()], 2)], 1), _vm.filteredChats.length === 0 ? _c("div", {
    staticClass: "empty-tip"
  }, [_c("i", {
    staticClass: "el-icon-chat-line-round",
    staticStyle: {
      "font-size": "48px",
      color: "#ddd"
    }
  }), _c("p", [_vm._v(_vm._s(_vm.listSearchKeyword ? "未找到匹配的会话" : "暂无会话"))])]) : _vm._e(), _vm._l(_vm.filteredChats, function (chat) {
    return _c("div", {
      key: chat.id,
      staticClass: "chat-item",
      class: {
        active: _vm.currentChatId === chat.id
      },
      on: {
        click: function click($event) {
          return _vm.openChat(chat);
        }
      }
    }, [_c("div", {
      staticClass: "chat-avatar",
      class: "chat-avatar--".concat(_vm.getChatCategory(chat))
    }, [chat.userType === 0 ? _c("i", {
      staticClass: "el-icon-s-check system-icon"
    }) : _vm.isGroupChat(chat) && !chat.avatar ? [_c("div", {
      staticClass: "group-avatar-grid",
      class: "count-".concat(_vm.getGroupAvatarTokens(chat).length)
    }, _vm._l(_vm.getGroupAvatarTokens(chat), function (token, tokenIndex) {
      return _c("span", {
        key: "".concat(chat.id, "_token_").concat(tokenIndex),
        staticClass: "group-avatar-tile",
        class: "tile-".concat(tokenIndex)
      }, [_vm._v(" " + _vm._s(token) + " ")]);
    }), 0)] : chat.avatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: chat.avatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s(_vm.getAvatarFallback(chat)))])], 2), _c("div", {
      staticClass: "chat-info"
    }, [_c("div", {
      staticClass: "chat-top-row"
    }, [_c("span", {
      staticClass: "chat-name"
    }, [_vm._v(_vm._s(chat.name || "未知"))]), _c("span", {
      staticClass: "chat-time"
    }, [_vm._v(_vm._s(_vm.formatConversationTime(chat.lastMessageTime)))])]), _c("div", {
      staticClass: "chat-last-msg",
      class: {
        matched: _vm.hasHistoryMatch(chat)
      }
    }, [_vm._v(" " + _vm._s(_vm.getChatPreview(chat)) + " ")])]), _vm.getUnread(chat) > 0 ? _c("el-badge", {
      staticClass: "unread-badge",
      attrs: {
        value: _vm.getUnread(chat)
      }
    }) : _vm._e()], 1);
  })], 2) : _vm._e(), _vm.view === "messages" ? _c("div", {
    staticClass: "messages-view"
  }, [_c("div", {
    ref: "messagesContainer",
    staticClass: "messages-list",
    on: {
      scroll: _vm.handleScroll
    }
  }, _vm._l(_vm.displayMessages, function (msg, index) {
    return _c("div", {
      key: "msg_wrap_" + index,
      staticClass: "msg-group-wrapper"
    }, [msg._showTime ? _c("div", {
      staticClass: "time-divider"
    }, [_c("span", [_vm._v(_vm._s(msg._timeLabel))])]) : _vm._e(), _c("div", {
      staticClass: "message-item",
      class: {
        mine: _vm.isMyMessage(msg),
        system: _vm.isSystemMessage(msg),
        recalled: msg.status === 1,
        "assistant-card-item": _vm.isAssistantCardMessage(msg)
      }
    }, [msg.status === 1 ? _c("div", {
      staticClass: "msg-recalled"
    }, [_c("span", [_vm._v('"' + _vm._s(_vm.isMyMessage(msg) ? "您" : msg.senderName || "对方") + '" 撤回了一条消息')])]) : _vm.isSystemMessage(msg) ? _c("div", {
      staticClass: "msg-system"
    }, [_c("span", [_vm._v(_vm._s(_vm.formatSystemMessage(msg)))])]) : [!_vm.isMyMessage(msg) && !_vm.isAssistantCardMessage(msg) ? _c("div", {
      staticClass: "msg-sender"
    }, [_vm._v(_vm._s(msg.senderName || "对方"))]) : _vm._e(), _c("div", {
      staticClass: "msg-content-row",
      class: {
        "msg-content-row--assistant-card": _vm.isAssistantCardMessage(msg)
      }
    }, [!_vm.isMyMessage(msg) ? _c("div", {
      staticClass: "msg-avatar"
    }, [_vm.getMsgAvatar(msg) ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: _vm.getMsgAvatar(msg)
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s(_vm.getMessageAvatarFallback(msg)))])]) : _vm._e(), _vm.isMyMessage(msg) && !msg._pending && !msg._failed && _vm.canRecall(msg) ? _c("div", {
      staticClass: "msg-recall-btn",
      on: {
        click: function click($event) {
          return _vm.recallMsg(msg);
        }
      }
    }, [_vm._v("撤回")]) : _vm._e(), _c("div", {
      staticClass: "msg-bubble",
      class: {
        pending: msg._pending,
        failed: msg._failed,
        "card-bubble": _vm.isCardMessage(msg),
        "approval-card-bubble": _vm.isApprovalCard(msg),
        "generic-card-bubble": _vm.isGenericCard(msg),
        "assistant-card-bubble": _vm.isAssistantCardMessage(msg)
      }
    }, [_vm.isApprovalCard(msg) ? _c("approval-message-card", {
      attrs: {
        card: _vm.getCardPayload(msg)
      },
      on: {
        click: _vm.openApprovalDetail
      }
    }) : _vm.isGenericCard(msg) ? _c("message-card", {
      attrs: {
        card: _vm.getCardPayload(msg)
      },
      on: {
        click: _vm.openCardDetail
      }
    }) : msg.messageType === 2 ? [_c("div", {
      staticClass: "image-message",
      class: {
        pending: msg._pending,
        failed: msg._failed
      }
    }, [msg.link ? _c("el-image", {
      staticStyle: {
        "max-width": "220px",
        "max-height": "220px",
        "border-radius": "12px",
        display: "block"
      },
      attrs: {
        src: msg.link,
        "preview-src-list": [msg.link],
        lazy: ""
      }
    }, [_c("div", {
      staticClass: "image-slot",
      attrs: {
        slot: "error"
      },
      slot: "error"
    }, [_c("i", {
      staticClass: "el-icon-picture-outline"
    })])]) : _c("div", {
      staticClass: "image-slot image-slot--empty"
    }, [_c("i", {
      staticClass: "el-icon-picture-outline"
    })]), msg._pending || msg._failed ? _c("div", {
      staticClass: "image-status-mask"
    }, [msg._pending ? _c("i", {
      staticClass: "el-icon-loading"
    }) : _c("i", {
      staticClass: "el-icon-warning-outline"
    }), _c("span", [_vm._v(_vm._s(msg._pending ? "发送中" : "发送失败"))])]) : _vm._e()], 1)] : msg.messageType === 4 ? [_c("div", {
      staticClass: "audio-msg",
      staticStyle: {
        display: "flex",
        "align-items": "center",
        cursor: "pointer",
        color: "#409EFF"
      }
    }, [_c("i", {
      staticClass: "el-icon-headset",
      staticStyle: {
        "margin-right": "5px"
      }
    }), _c("span", [_vm._v("[语音消息，请在App端查看]")])])] : msg.messageType === 3 ? [_c("div", {
      staticClass: "video-msg",
      staticStyle: {
        display: "flex",
        "align-items": "center",
        cursor: "pointer",
        color: "#409EFF"
      }
    }, [_c("i", {
      staticClass: "el-icon-video-camera",
      staticStyle: {
        "margin-right": "5px"
      }
    }), _c("span", [_vm._v("[视频消息，请在App端查看]")])])] : [_c("div", {
      staticClass: "msg-text",
      domProps: {
        innerHTML: _vm._s(_vm.renderTextContent(msg))
      }
    })]], 2), _vm.isMyMessage(msg) ? _c("div", {
      staticClass: "msg-avatar msg-avatar--mine"
    }, [_vm.userAvatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: _vm.userAvatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((_vm.userName || "?")[0]))])]) : _vm._e()]), msg._pending || msg._failed ? _c("div", {
      staticClass: "msg-status-row",
      class: {
        mine: _vm.isMyMessage(msg)
      }
    }, [msg._pending ? _c("div", {
      staticClass: "msg-status msg-status--pending"
    }, [_c("i", {
      staticClass: "el-icon-loading"
    }), _c("span", [_vm._v("发送中")])]) : _c("div", {
      staticClass: "msg-status msg-status--failed",
      on: {
        click: function click($event) {
          return _vm.retryMessage(msg);
        }
      }
    }, [_c("i", {
      staticClass: "el-icon-refresh"
    }), _c("span", [_vm._v("点击重试")])])]) : _vm._e()]], 2)]);
  }), 0), _vm.newMessageHintCount > 0 ? _c("button", {
    staticClass: "new-message-hint",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleNewMessageHintClick
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-down"
  }), _vm._v(" " + _vm._s(_vm.newMessageHintCount > 99 ? "99+条新消息" : "".concat(_vm.newMessageHintCount, "\u6761\u65B0\u6D88\u606F")) + " ")]) : _vm._e(), _c("div", {
    staticClass: "input-area"
  }, [_c("div", {
    staticClass: "chat-toolbar"
  }, [_c("el-upload", {
    staticClass: "chat-upload",
    attrs: {
      action: "/api/v5/sys/upload/image",
      headers: _vm.uploadHeaders,
      "show-file-list": false,
      "on-success": _vm.handleImageUpload,
      "before-upload": _vm.beforeImageUpload,
      accept: "image/*",
      disabled: !_vm.canCurrentUserSendInSelectedChat
    }
  }, [_c("i", {
    staticClass: "el-icon-picture-outline toolbar-icon",
    attrs: {
      title: "图片"
    }
  })]), _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "310",
      trigger: "click",
      disabled: !_vm.canCurrentUserSendInSelectedChat
    }
  }, [_c("div", {
    staticClass: "emoji-picker"
  }, _vm._l(_vm.emojiList, function (emoji) {
    return _c("span", {
      key: emoji,
      staticClass: "emoji-item",
      on: {
        click: function click($event) {
          return _vm.insertEmoji(emoji);
        }
      }
    }, [_vm._v(" " + _vm._s(emoji) + " ")]);
  }), 0), _c("span", {
    staticClass: "toolbar-icon emoji-btn",
    attrs: {
      slot: "reference",
      title: "表情"
    },
    slot: "reference"
  }, [_vm._v("😊")])])], 1), _c("div", {
    staticClass: "input-row"
  }, [_c("el-input", {
    ref: "msgInput",
    attrs: {
      type: "textarea",
      rows: 2,
      placeholder: _vm.selectedChatInputPlaceholder,
      disabled: !_vm.canCurrentUserSendInSelectedChat,
      autosize: {
        minRows: 1,
        maxRows: 4
      }
    },
    nativeOn: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputText,
      callback: function callback($$v) {
        _vm.inputText = $$v;
      },
      expression: "inputText"
    }
  }), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      icon: "el-icon-s-promotion",
      disabled: !_vm.canCurrentUserSendInSelectedChat || !_vm.inputText.trim()
    },
    on: {
      click: _vm.sendMessage
    }
  }, [_vm._v("发送")])], 1)])]) : _vm._e(), _vm.view === "customerService" ? _c("div", {
    staticClass: "customer-service-view"
  }, [_c("customer-service-panel", {
    attrs: {
      agent: _vm.customerServiceAgent,
      active: _vm.view === "customerService"
    }
  })], 1) : _vm._e(), _vm.view === "groupDetail" ? _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.groupDetailLoading,
      expression: "groupDetailLoading"
    }],
    staticClass: "group-detail-view"
  }, [_c("div", {
    staticClass: "group-hero"
  }, [_c("div", {
    staticClass: "group-hero-avatar",
    class: {
      "group-hero-avatar--editable": _vm.canEditGroupInfo
    },
    on: {
      click: _vm.handleGroupAvatarClick
    }
  }, [_vm.selectedChat && _vm.selectedChat.avatar ? _c("img", {
    staticClass: "avatar-img",
    attrs: {
      src: _vm.selectedChat.avatar
    }
  }) : _c("span", {
    staticClass: "avatar-text"
  }, [_vm._v(_vm._s(_vm.getGroupDetailAvatarText()))])]), _c("input", {
    ref: "groupAvatarInput",
    staticStyle: {
      display: "none"
    },
    attrs: {
      type: "file",
      accept: "image/*"
    },
    on: {
      change: _vm.handleGroupAvatarFileChange
    }
  }), _c("div", {
    staticClass: "group-hero-meta"
  }, [_c("div", {
    staticClass: "group-hero-name"
  }, [_vm._v(_vm._s(((_vm$selectedChat = _vm.selectedChat) === null || _vm$selectedChat === void 0 ? void 0 : _vm$selectedChat.name) || "未命名群聊"))]), _c("div", {
    staticClass: "group-hero-sub"
  }, [_c("span", [_vm._v(_vm._s(_vm.groupMemberCount) + "人")]), _vm.canEditGroupInfo ? _c("span", {
    staticClass: "group-hero-sub-tip"
  }, [_vm._v("点击左侧头像可修改")]) : _vm._e()])]), _c("button", {
    staticClass: "group-hero-qr",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$message.info("群二维码能力下一步补");
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-share"
  })])]), _c("div", {
    staticClass: "group-section"
  }, [_c("div", {
    staticClass: "group-section-title"
  }, [_vm._v("群成员")]), _c("div", {
    staticClass: "group-member-grid"
  }, [_vm._l(_vm.groupPreviewMembers, function (member) {
    return _c("div", {
      key: "".concat(member.userId, "_").concat(member.role),
      staticClass: "group-member-tile"
    }, [_c("div", {
      staticClass: "group-member-avatar"
    }, [member.userAvatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: member.userAvatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((member.userName || "?")[0]))])]), _c("div", {
      staticClass: "group-member-name"
    }, [_vm._v(_vm._s(member.userName || "未知成员"))]), _c("div", {
      staticClass: "group-member-role"
    }, [_vm._v(_vm._s(_vm.getGroupRoleLabel(member.role)))])]);
  }), _vm.canInviteGroupMember ? _c("button", {
    staticClass: "group-member-tile group-member-tile--action",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$message.info("Web 端邀请成员下一步补");
      }
    }
  }, [_c("div", {
    staticClass: "group-member-avatar group-member-avatar--action"
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })]), _c("div", {
    staticClass: "group-member-name"
  }, [_vm._v("邀请成员")]), _c("div", {
    staticClass: "group-member-role"
  }, [_vm._v("可管理")])]) : _vm._e()], 2), _c("button", {
    staticClass: "group-more-members",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.openAllGroupMembers
    }
  }, [_vm._v(" 查看全部群成员（" + _vm._s(_vm.groupMemberCount) + "人） "), _c("i", {
    staticClass: "el-icon-arrow-right"
  })])]), _c("div", {
    staticClass: "group-section"
  }, [_c("div", {
    staticClass: "group-section-title"
  }, [_vm._v("群操作")]), _c("div", {
    staticClass: "group-operation-list"
  }, _vm._l(_vm.groupOperationItems, function (item) {
    return _c("button", {
      key: item.key,
      staticClass: "group-operation-item",
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.handleGroupAction(item);
        }
      }
    }, [_c("div", {
      staticClass: "group-operation-icon"
    }, [_c("i", {
      class: item.icon
    })]), _c("div", {
      staticClass: "group-operation-meta"
    }, [_c("div", {
      staticClass: "group-operation-label"
    }, [_vm._v(_vm._s(item.label))]), _c("div", {
      staticClass: "group-operation-desc"
    }, [_vm._v(_vm._s(item.desc))])]), _c("i", {
      staticClass: "el-icon-arrow-right group-operation-arrow"
    })]);
  }), 0)])]) : _vm._e(), _vm.view === "groupMembers" ? _c("div", {
    staticClass: "group-members-view"
  }, [_vm.groupMembers.length === 0 ? _c("div", {
    staticClass: "empty-tip"
  }, [_c("p", [_vm._v("暂无群成员")])]) : _c("div", {
    staticClass: "group-members-list"
  }, _vm._l(_vm.groupMembers, function (member) {
    return _c("div", {
      key: "member_".concat(member.userId),
      staticClass: "group-members-row"
    }, [_c("div", {
      staticClass: "group-members-avatar"
    }, [member.userAvatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: member.userAvatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((member.userName || "?")[0]))])]), _c("div", {
      staticClass: "group-members-meta"
    }, [_c("div", {
      staticClass: "group-members-name"
    }, [_vm._v(_vm._s(member.userName || "未知成员"))]), _c("div", {
      staticClass: "group-members-role"
    }, [_vm._v(" " + _vm._s(_vm.isCurrentGroupMember(member) ? "我" : _vm.getGroupRoleLabel(member.role)) + " ")])]), _vm.getGroupMemberActions(member).length > 0 ? _c("div", {
      staticClass: "group-members-actions"
    }, [_c("el-dropdown", {
      attrs: {
        trigger: "click"
      },
      on: {
        command: function command(_command) {
          return _vm.handleGroupMemberAction(_command, member);
        }
      }
    }, [_c("button", {
      staticClass: "group-members-actions-btn",
      attrs: {
        type: "button"
      }
    }, [_c("i", {
      staticClass: "el-icon-more"
    })]), _c("el-dropdown-menu", {
      attrs: {
        slot: "dropdown"
      },
      slot: "dropdown"
    }, _vm._l(_vm.getGroupMemberActions(member), function (action) {
      return _c("el-dropdown-item", {
        key: "".concat(member.userId, "_").concat(action.key),
        attrs: {
          command: action.key
        }
      }, [_vm._v(" " + _vm._s(action.label) + " ")]);
    }), 1)], 1)], 1) : _vm._e()]);
  }), 0)]) : _vm._e(), _vm.view === "newChat" ? _c("div", {
    staticClass: "new-chat-view"
  }, [_c("el-input", {
    attrs: {
      placeholder: "搜索姓名、手机号",
      "prefix-icon": "el-icon-search",
      clearable: ""
    },
    on: {
      input: _vm.debounceSearch
    },
    model: {
      value: _vm.searchKeyword,
      callback: function callback($$v) {
        _vm.searchKeyword = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "searchKeyword"
    }
  }), _c("div", {
    staticClass: "contact-type-tabs"
  }, _vm._l(_vm.contactTypeOptions, function (item) {
    return _c("button", {
      key: item.value,
      staticClass: "contact-type-tab",
      class: {
        active: _vm.selectedContactType === item.value,
        disabled: item.disabled
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.selectContactType(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " "), item.disabled ? _c("span", {
      staticClass: "contact-type-soon"
    }, [_vm._v("待开放")]) : _vm._e()]);
  }), 0), _vm.availableOrgCities.length > 0 && !_vm.searchKeyword ? _c("div", {
    staticClass: "org-city-tabs"
  }, _vm._l(_vm.availableOrgCities, function (city) {
    return _c("button", {
      key: "org_city_".concat(city.key),
      staticClass: "org-city-tab",
      class: {
        active: _vm.selectedOrgCityKey === city.key
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.selectOrgCity(city.key);
        }
      }
    }, [_vm._v(" " + _vm._s(city.label) + " ")]);
  }), 0) : _vm._e(), _vm.schoolsInSelectedCity.length > 0 ? _c("div", {
    staticClass: "org-school-tabs"
  }, _vm._l(_vm.schoolsInSelectedCity, function (school) {
    return _c("button", {
      key: "org_school_".concat(school.id),
      staticClass: "org-school-tab",
      class: {
        active: String(_vm.selectedOrgSchoolId) === String(school.id)
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.selectOrgSchool(school.id);
        }
      }
    }, [_vm._v(" " + _vm._s(school.name) + " ")]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "search-results",
    class: {
      browsing: !_vm.searchKeyword
    }
  }, [_vm.searchLoading || _vm.orgUsersLoading || _vm.orgDeptsLoading || _vm.orgSchoolsLoading || _vm.studentFacultiesLoading ? _c("div", {
    staticClass: "search-loading"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" 搜索中... ")]) : _vm.searchKeyword ? [_vm._l(_vm.searchResults, function (user) {
    return _c("div", {
      key: user.id,
      staticClass: "user-item",
      on: {
        click: function click($event) {
          return _vm.startChatWith(user);
        }
      }
    }, [_c("div", {
      staticClass: "user-avatar"
    }, [user.avatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: user.avatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((user.name || "?")[0]))])]), _c("div", {
      staticClass: "user-info"
    }, [_c("div", {
      staticClass: "user-name-row"
    }, [_c("span", {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.name))]), _vm.selectedContactType === "student" || _vm.getUserPrimaryRole(user) ? _c("span", {
      staticClass: "user-role-tag"
    }, [_vm._v(" " + _vm._s(_vm.selectedContactType === "student" ? "学生" : _vm.getUserPrimaryRole(user)) + " ")]) : _vm._e()]), _c("div", {
      staticClass: "user-meta-row"
    }, [_c("span", {
      staticClass: "user-school"
    }, [_vm._v(" " + _vm._s(_vm.selectedContactType === "student" ? _vm.getStudentSchoolName(user) : _vm.getUserSchoolName(user)) + " ")]), _c("span", {
      staticClass: "user-dept"
    }, [_vm._v(" " + _vm._s(_vm.selectedContactType === "student" ? _vm.getStudentOrgPath(user) : _vm.getUserDeptName(user)) + " ")])])])]);
  }), _vm.searchResults.length === 0 ? _c("div", {
    staticClass: "empty-tip"
  }, [_c("p", [_vm._v("未找到用户")])]) : _vm._e()] : _vm.selectedContactType === "parent" || _vm.selectedContactType === "supplier" ? _c("div", {
    staticClass: "empty-tip"
  }, [_c("p", [_vm._v(_vm._s(_vm.selectedContactType === "parent" ? "家长联系人入口后续补充" : "供应商联系人入口后续补充"))])]) : _vm.selectedContactType === "student" ? _c("div", {
    staticClass: "student-browser"
  }, [_c("div", {
    staticClass: "student-breadcrumbs"
  }, _vm._l(_vm.studentBreadcrumbs, function (crumb, index) {
    return _c("button", {
      key: "student_crumb_".concat(index, "_").concat(crumb.level),
      staticClass: "student-breadcrumb",
      class: {
        active: index === _vm.studentBreadcrumbs.length - 1
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.handleStudentBreadcrumbClick(crumb, index);
        }
      }
    }, [_vm._v(" " + _vm._s(crumb.label) + " ")]);
  }), 0), _c("div", {
    staticClass: "student-browser-body",
    class: {
      "student-browser-body--single": _vm.selectedStudentClazzId
    }
  }, [!_vm.selectedStudentClazzId ? _c("div", {
    staticClass: "student-side-panel"
  }, _vm._l(_vm.currentStudentPanelItems, function (item) {
    return _c("button", {
      key: "student_panel_".concat(item.type, "_").concat(item.id || "all"),
      staticClass: "student-side-item",
      class: {
        active: _vm.getStudentPanelItemKey(item) === _vm.studentPanelSelectionKey
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.selectStudentPanelItem(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "student-user-panel"
  }, [_c("div", {
    staticClass: "student-user-panel-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.studentBrowserTitle))]), _vm.studentPanelBusy ? _c("span", {
    staticClass: "student-panel-loading"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" 更新中 ")]) : _vm._e()]), _vm._l(_vm.studentUsers, function (user) {
    return _c("div", {
      key: "student_user_".concat(user.id),
      staticClass: "user-item",
      on: {
        click: function click($event) {
          _vm.startChatWith(_vm.normalizeStudentContact(user));
        }
      }
    }, [_c("div", {
      staticClass: "user-avatar"
    }, [_vm.getStudentAvatar(user) ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: _vm.getStudentAvatar(user)
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((user.name || "?")[0]))])]), _c("div", {
      staticClass: "user-info"
    }, [_c("div", {
      staticClass: "user-name-row"
    }, [_c("span", {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.name))]), _c("span", {
      staticClass: "user-role-tag"
    }, [_vm._v("学生")])]), _c("div", {
      staticClass: "user-meta-row"
    }, [_c("span", {
      staticClass: "user-school"
    }, [_vm._v(_vm._s(_vm.getStudentSchoolName(user)))]), _c("span", {
      staticClass: "user-dept"
    }, [_vm._v(_vm._s(_vm.getStudentOrgPath(user)))])]), user.phone ? _c("div", {
      staticClass: "user-phone"
    }, [_vm._v(_vm._s(user.phone))]) : _vm._e()])]);
  }), _vm.studentUsers.length === 0 ? _c("div", {
    staticClass: "empty-tip empty-tip--compact"
  }, [_c("p", [_vm._v("当前层级下暂无学生")])]) : _vm._e()], 2)])]) : _c("div", {
    staticClass: "org-browser"
  }, [_c("div", {
    staticClass: "org-dept-panel"
  }, [_c("button", {
    staticClass: "org-dept-item",
    class: {
      active: !_vm.selectedOrgDeptId
    },
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.selectOrgDept(null);
      }
    }
  }, [_vm._v(" 全部部门 ")]), _vm._l(_vm.filteredOrgDepts, function (dept) {
    return _c("button", {
      key: "org_dept_".concat(dept.id),
      staticClass: "org-dept-item",
      class: {
        active: String(_vm.selectedOrgDeptId) === String(dept.id)
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.selectOrgDept(dept.id);
        }
      }
    }, [_c("span", {
      staticClass: "org-dept-name"
    }, [_vm._v(_vm._s(dept.name))])]);
  })], 2), _c("div", {
    staticClass: "org-user-panel"
  }, [_vm._l(_vm.filteredOrgUsers, function (user) {
    return _c("div", {
      key: "org_user_".concat(user.id),
      staticClass: "user-item",
      on: {
        click: function click($event) {
          return _vm.startChatWith(user);
        }
      }
    }, [_c("div", {
      staticClass: "user-avatar"
    }, [user.avatar ? _c("img", {
      staticClass: "avatar-img",
      attrs: {
        src: user.avatar
      }
    }) : _c("span", {
      staticClass: "avatar-text"
    }, [_vm._v(_vm._s((user.name || "?")[0]))])]), _c("div", {
      staticClass: "user-info"
    }, [_c("div", {
      staticClass: "user-name-row"
    }, [_c("span", {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.name))]), _vm.getUserPrimaryRole(user) ? _c("span", {
      staticClass: "user-role-tag"
    }, [_vm._v(_vm._s(_vm.getUserPrimaryRole(user)))]) : _vm._e()]), _c("div", {
      staticClass: "user-meta-row"
    }, [_c("span", {
      staticClass: "user-school"
    }, [_vm._v(_vm._s(_vm.getUserSchoolName(user)))]), _c("span", {
      staticClass: "user-dept"
    }, [_vm._v(_vm._s(_vm.getUserDeptName(user)))])]), user.phone ? _c("div", {
      staticClass: "user-phone"
    }, [_vm._v(_vm._s(user.phone))]) : _vm._e()])]);
  }), _vm.filteredOrgUsers.length === 0 ? _c("div", {
    staticClass: "empty-tip empty-tip--compact"
  }, [_c("p", [_vm._v("当前筛选下暂无联系人")])]) : _vm._e()], 2)])], 2)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };